import styled from "@emotion/styled";
import { GrBox, palette, typography } from "@jnpmedi/grebob";
import { LayoutContextProps } from "@newHooks/context/layout/layout.context";
import { baseZIndex } from "@assets/theme/baseDefine/baseZIndex";
import { baseHeight } from "@assets/theme/baseSize/baseHeight";
import { baseWidth } from "@assets/theme/baseSize/baseWidth";

const SideBarWrapper = styled("aside")<Pick<LayoutContextProps, "sidebarCollapsed">>(({ sidebarCollapsed }) => ({
  position: "fixed",
  top: 0,
  bottom: 0,
  left: 0,
  zIndex: baseZIndex.layout.leftSideBar,
  overflow: "hidden",
  maxHeight: "100%",
  background: palette.white,
  transition: "all ease-in-out 0.23s",
  "&:not(:hover)": {
    width: sidebarCollapsed.value ? baseWidth.appSidebarWidth : baseWidth.appSidebarWidthCollapsed,
    ".sidebar-logo-text, .sidebar-pin, .menu-item-text": {
      opacity: sidebarCollapsed.value ? 1 : 0,
    },
    ".logo-name": {
      display: sidebarCollapsed.value ? "block" : "none",
    },
    ".version-text": {
      visibility: sidebarCollapsed.value ? "inherit" : "hidden",
    },
    "@media (max-width: 1024px)": {
      width: baseWidth.appSidebarWidthCollapsed,
      ".sidebar-logo-text, .sidebar-pin, .menu-item-text": {
        opacity: 0,
      },
      ".logo-name": {
        display: "none",
      },
      ".version-text": {
        visibility: "hidden",
      },
    },
  },
  "&:hover": {
    width: baseWidth.appSidebarWidth,
    ".sidebar-logo-text": {
      opacity: 1,
    },
    ".sidebar-pin": {
      opacity: 1,
    },
    "@media (max-width: 1024px)": {
      ".sidebar-pin": {
        opacity: 0,
      },
    },
  },
}));

const SideBarSection = styled(GrBox)({
  position: "relative",
  width: "100%",
  height: "100%",
});

const LogoWrapper = styled(GrBox)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  width: "100%",
  height: baseHeight.appHeaderHeight,
  background: palette.white,
  color: palette.blue050,
  userSelect: "none",
  lineHeight: baseHeight.appHeaderHeight,
  a: {
    display: "flex",
    top: 18,
    marginLeft: 16,
    color: palette.blue050,
    ...typography["Content.Subtitle02"],
    textDecoration: "none",
    transition: "all ease-in-out 0.23s",
  },
  span: {
    marginLeft: "12px",
  },
});

const PinWrapper = styled("div")({
  position: "absolute",
  top: "0px",
  right: "0px",
  height: baseHeight.appHeaderHeight,
  display: "flex",
  width: "28px",
  alignItems: "center",
  transition: "all ease-in-out 0.23s",
  cursor: "pointer",
});

const VersionWrapper = styled(GrBox)({
  width: "100%",
  textAlign: "left",
  userSelect: "none",
  whiteSpace: "nowrap",
  color: palette["blue060"],
  ...typography["Content.Caption04"],
  marginLeft: "22px",
});

const Style = {
  SideBarWrapper,
  SideBarSection,
  LogoWrapper,
  PinWrapper,
  VersionWrapper,
};

export default Style;
